"use client";

import { Challenge } from "@/lib/challengePaths";
import React, { FC } from "react";

interface Props {
  challenge: Challenge;
  estimateInput: string;
  handleEstimateInput: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleEstimateSubmit: () => void;
}
export const EstimateChallengeForm: FC<Props> = ({
  challenge,
  estimateInput,
  handleEstimateInput,
  handleEstimateSubmit,
}) => {
  return (
    <>
      <p className="text-lg text-white mb-4">{challenge.question}</p>
      {challenge.hint && (
        <p className="text-sm text-gray-400 mb-4 italic">
          Hint: {challenge.hint}
        </p>
      )}
      <div className="space-y-4">
        <input
          type="number"
          value={estimateInput}
          onChange={handleEstimateInput}
          placeholder="Enter your estimate (%)..."
          className="w-full p-4 bg-white/5 border border-white/10 rounded-xl text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-teal"
        />
        <button
          onClick={handleEstimateSubmit}
          disabled={!estimateInput.trim()}
          className="w-full bg-brand-teal hover:bg-brand-teal disabled:bg-gray-600 disabled:cursor-not-allowed text-white py-3 rounded-xl font-semibold transition-colors"
        >
          Submit Estimate
        </button>
      </div>
    </>
  );
};
